var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	9087: {
		fallback: () => (() => (__webpack_require__(70629))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/router",

	},
	21301: {
		fallback: () => (() => (__webpack_require__(24358))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/head",

	},
	75244: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(44489))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	46467: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(44349))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	24137: {
		fallback: () => (() => (__webpack_require__(24518))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "react-dom",

	},
	51301: {
		fallback: () => (() => (__webpack_require__(15084))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/link",

	},
	41070: {
		fallback: () => (__webpack_require__.e(5843).then(() => (() => (__webpack_require__(75843))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/script",

	},
	27712: {
		fallback: () => (__webpack_require__.e(8841).then(() => (() => (__webpack_require__(58841))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/image",

	},
	4312: {
		fallback: () => (__webpack_require__.e(9393).then(() => (() => (__webpack_require__(29393))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/dynamic",

	},
	83676: {
		fallback: () => (__webpack_require__.e(7738).then(() => (() => (__webpack_require__(77738))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	75065: {
		fallback: () => (__webpack_require__.e(19).then(() => (() => (__webpack_require__(10019))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	85233: {
		fallback: () => (() => (__webpack_require__(9971))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.5.2",
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "zustand",

	},
	94014: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(72181))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	84685: {
		fallback: () => (__webpack_require__.e(8496).then(() => (() => (__webpack_require__(68496))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "@tanstack/react-query",

	},
	35657: {
		fallback: () => (__webpack_require__.e(1174).then(() => (() => (__webpack_require__(51174))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "i18next",

	},
	52949: {
		fallback: () => (__webpack_require__.e(8386).then(() => (() => (__webpack_require__(58386))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-i18next",

	},
	91324: {
		fallback: () => (__webpack_require__.e(2732).then(() => (() => (__webpack_require__(52732))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-hook-form",

	},
	43691: {
		fallback: () => (__webpack_require__.e(1178).then(() => (() => (__webpack_require__(71178))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-lazily",

	},
	14084: {
		fallback: () => (() => (__webpack_require__(64435))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/compat/router",

	},
	5315: {
		fallback: () => (__webpack_require__.e(1746).then(() => (() => (__webpack_require__(61746))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "dompurify",

	},
	88402: {
		fallback: () => (__webpack_require__.e(3288).then(() => (() => (__webpack_require__(53288))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-tooltip",

	},
	96236: {
		fallback: () => (Promise.all([__webpack_require__.e(5541), __webpack_require__.e(4742)]).then(() => (() => (__webpack_require__(94742))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-phone-number-input",

	},
	15957: {
		fallback: () => (() => (__webpack_require__(95445))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-toast-store",

	},
	30272: {
		fallback: () => (__webpack_require__.e(4330).then(() => (() => (__webpack_require__(14330))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "axios",

	},
	482: {
		fallback: () => (Promise.all([__webpack_require__.e(5541), __webpack_require__.e(2992)]).then(() => (() => (__webpack_require__(92992))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-phone-number-input",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [9087,21301,75244,46467,24137,51301,41070,27712,4312,83676,75065,85233,75244,46467,94014,24137,85233,84685,35657,52949,21301,27712,91324,43691,14084,51301,5315,41070,88402,96236,15957,30272,482];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"482": [
		482
	],
	"636": [
		84685,
		35657,
		52949,
		21301,
		27712,
		91324,
		43691,
		14084,
		51301,
		5315,
		41070,
		88402,
		96236
	],
	"4450": [
		15957,
		30272
	],
	"5527": [
		21301,
		75244,
		46467,
		24137,
		51301,
		41070,
		27712,
		4312,
		83676,
		75065,
		85233
	],
	"8792": [
		75244,
		46467,
		94014,
		24137,
		85233
	],
	"9087": [
		9087
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}